"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "form-block brand-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "responsive-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-width": "160px",
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Enabled",
      prop: "enabled"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "enabled", $$v);
      },
      expression: "formData.enabled"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Name",
      prop: "name"
    }
  }, [_c("el-input", {
    attrs: {
      name: "name",
      required: "",
      placeholder: "Brand Name"
    },
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", $$v);
      },
      expression: "formData.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Icon"
    }
  }, [_c("div", {
    staticClass: "icon-upload-wrapper"
  }, [_vm.formData.image ? _c("div", {
    staticClass: "icon-preview"
  }, [_c("img", {
    attrs: {
      src: _vm.formData.image
    }
  }), _c("div", {
    staticClass: "overlay"
  }, [_c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: function ($event) {
        _vm.formData.image = "";
      }
    }
  }, [_vm._v(" Change ")])], 1)]) : _c("div", {
    staticClass: "upload-box",
    on: {
      click: _vm.triggerFileInput
    }
  }, [_c("i", {
    staticClass: "el-icon-plus upload-icon"
  }), _c("p", [_vm._v("Click to upload icon")]), _c("small", [_vm._v("PNG / JPG (1:1 ratio)")]), _c("input", {
    ref: "fileInput",
    attrs: {
      type: "file",
      accept: ".jpg,.jpeg,.png",
      hidden: ""
    },
    on: {
      change: _vm.onFileSelected
    }
  })])])]), _c("el-dialog", {
    attrs: {
      visible: _vm.cropperVisible,
      width: "90%",
      "custom-class": "cropper-dialog",
      "append-to-body": ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.cropperVisible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "cropper-wrapper"
  }, [_c("cropper", {
    ref: "cropper",
    attrs: {
      src: _vm.imageSrc,
      "stencil-props": {
        aspectRatio: 1
      }
    }
  })], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.cropperVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.cropImage
    }
  }, [_vm._v(" Crop & Upload ")])], 1)]), _c("el-form-item", {
    staticClass: "action-buttons"
  }, [_vm.isSuperAdmin ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]) : _vm._e(), _vm.isSuperAdmin ? _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "info"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")]) : _vm._e()], 1)], 1)], 1)])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;